// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { baseUrl } from './../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getAllImagesList = createAsyncThunk(
    'AppThemeImages/getAllImagesList',
    async (params) => {
        const response = await axios.get(baseUrl() + '/themeImage')
        return {
            //totalPages: response.data.count.total,
            //params: response.data.params,
            imagesList: response.data.data,
            //filterParams: params
        }
    }
)


export const getThemeImgById = createAsyncThunk(
    'AppThemeImages/getThemeImgById',
    async ({ topicId }) => {
        const response = await axios.get(baseUrl() + `/themeImage/${topicId}`)
        return {
            themeImgById: response?.data?.data[0]
        }
    }
)


export const addThemeImg = createAsyncThunk(
    'AppThemeImages/addThemeImg',
    async ({ payload }, { dispatch }) => {
        try {
            await axios.post(baseUrl() + '/themeImage/add', payload)
            toast.success('Image added successfully')
            await dispatch(
                getAllImagesList()
            )
            //return AppThemeImages
        } catch (error) {
            toast.error(error?.response?.data)
        }
    }
)


export const updateThemeImg = createAsyncThunk(
    'AppThemeImages/updateThemeImg',
    async ({ id, payload, params }, { dispatch }) => {
        try {
            await axios.put(baseUrl() + `/themeImage/update/${id}`, payload)
            toast.success('Image Updated successfully')
            await dispatch(
                getAllImagesList({
                    params
                })
            )
            return { id }
        } catch (error) {
            toast.error(error?.response?.data)
        }
    }
)

export const deleteThemeImg = createAsyncThunk(
    'AppThemeImages/deleteThemeImg',
    async ({ id, pageNo, pageSize }, { dispatch }) => {
        try {
            dispatch(setLoader())
            await axios.delete(baseUrl() + '/themeImage/' + id)
            toast.success('Image Deleted successfully')
            await dispatch(
                getAllImagesList({
                    pageNo,
                    pageSize
                })
            )
            return id
        } catch (error) {
            toast.error(error?.response?.data)
        }
    }
)

export const themeImgSlice = createSlice({
    name: 'AppThemeImages',
    initialState: {
        imagesList: [],
        themeImgById: [],
        selected: null,
        loader: true,
        currentPage: 1,
        rowsPerPage: 10,
        totalPages: 0,
        clearFilter: false,
        filterParams: {}
    },
    reducers: {
        selectThemeImage: (state, action) => {
            if (action.payload === null) {
                state.selected = null
            } else {
                state.selected = action.payload
            }
        },
        setLoader: (state, action) => {
            state.loader = action.payload
        },
        selectCurrentPage: (state, action) => {
            if (action.payload === null) {
                state.currentPage = null
            } else {
                state.currentPage = action.payload
            }
        },
        selectRowsPerPage: (state, action) => {
            if (action.payload === null) {
                state.rowsPerPage = null
            } else {
                state.rowsPerPage = action.payload
            }
        },
        selectClearFilter: (state) => {
            state.clearFilter = !state.clearFilter
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllImagesList.fulfilled, (state, action) => {
                ; (state.imagesList = action.payload.imagesList),
                    (state.totalPages = action.payload.totalPages)
                //state.filterParams = action?.payload?.filterParams
                state.loader = false
            })

            .addCase(getAllImagesList.pending, (state) => {
                state.loader = false
            })
            .addCase(getThemeImgById.fulfilled, (state, action) => {
                state.themeImgById = action.payload.themeImgById
            })
    }
})

export const {
    selectThemeImage,
    setLoader,
    selectClearFilter,
    selectCurrentPage,
    selectRowsPerPage
} = themeImgSlice.actions

export default themeImgSlice.reducer
